import { Component, HostListener, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { AidePanneauComponent } from '../aide-panneau/aide-panneau.component';

/**
 * Bouton « ? » de la barre du haut : ouvre le panneau d'aide (qui propose la
 * visite guidée) [D6]. Raccourci clavier « ? », sauf pendant une saisie.
 */
@Component({
  selector: 'app-aide-bouton',
  standalone: true,
  imports: [TooltipModule, AidePanneauComponent],
  template: `
    <button type="button" class="layout-topbar-action" data-tour="walkthrough-btn"
            pTooltip="Aide" tooltipPosition="bottom" aria-label="Aide" (click)="basculer()">
      <i class="fa-light fa-question-circle"></i>
    </button>
    <app-aide-panneau />
  `,
  styles: [`:host { display: contents; }`],
})
export class AideBoutonComponent {
  private readonly router = inject(Router);
  private readonly panneau = viewChild.required(AidePanneauComponent);

  basculer(): void {
    const panneau = this.panneau();
    if (panneau.visible()) {
      panneau.visible.set(false);
    } else {
      panneau.ouvrir();
    }
  }

  @HostListener('document:keydown', ['$event'])
  raccourci(evenement: KeyboardEvent): void {
    if (evenement.key !== '?' || evenement.ctrlKey || evenement.metaKey || evenement.altKey
        || enSaisie(evenement) || /\/builder(\/|\?|$)/.test(this.router.url)) {
      return;
    }
    evenement.preventDefault();
    this.basculer();
  }
}

/** Champ, éditeur de texte, cadre (iframe) : le « ? » s'écrit, il n'ouvre pas l'aide. */
export function enSaisie(evenement: KeyboardEvent): boolean {
  const cible = (evenement.target as HTMLElement | null) ?? null;
  const actif = typeof document !== 'undefined' ? (document.activeElement as HTMLElement | null) : null;
  return [cible, actif].some((el) => !!el && (
    el.isContentEditable
    || ['INPUT', 'TEXTAREA', 'SELECT', 'IFRAME'].includes(el.tagName)
    || !!el.closest?.('[contenteditable=""], [contenteditable="true"], .p-editor, .ql-editor, .gjs-editor, [role="textbox"]')
  ));
}
